module.exports = {"id":"201447","name":"Sebastian Lletget","rating":"71","photo":"./data/images/photos/2/201447.png","club":{"name":"LA Galaxy","logo":"./data/images/clubs/LAGalaxy.png"},"positions":["MD","MG","MC","MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SebastianLletget0.json
// module id = 3863
// module chunks = 0